import type { RoomMode } from "@/engine/state/roomControl";

/**
 * The four kinds of room, in the order the landing describes them.
 *
 * **Written out rather than read from `ROOM_MODES`.** That list lives beside
 * the room's schema, and importing it would pull the control state and its
 * schemas into the page a visitor fetches first (#615). The import above is a
 * type and is erased, so the four names are still checked; that this list is the
 * whole of that one is `LandingDemo.test.tsx`'s to say.
 *
 * The plainest last: a visitor reading down the page meets what the product is
 * about before what it also does.
 */
export const LANDING_MODES: readonly RoomMode[] = [
  "campfire",
  "bubbles",
  "teams",
  "plain",
];
